import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {usePaymentInputs} from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import './creditCardPayment.scss';

function* range(start, end, step) {
  while (start < end) {
    yield start;
    start += step;
  }
}

const CreditCardPayment = ({t, setCardData}) => {
  const ERROR_MESSAGES = {
    emptyCardNumber: t('payment.credit_card.errors.empty_card_number'),
    invalidCardNumber: t('payment.credit_card.errors.invalid_card_number'),
    emptyExpiryDate: t('payment.credit_card.errors.empty_expiry_date'),
    monthOutOfRange: t('payment.credit_card.errors.month_out_of_range'),
    yearOutOfRange: t('payment.credit_card.errors.year_out_of_range'),
    dateOutOfRange: t('payment.credit_card.errors.date_out_o_range'),
    invalidExpiryDate: t('payment.credit_card.errors.invalid_expiry_date'),
    emptyCVC: t('payment.credit_card.errors.empty_cvc'),
    invalidCVC: t('payment.credit_card.errors.invalid_cvc')
  };

  const {
    meta,
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps
  } = usePaymentInputs({errorMessages: ERROR_MESSAGES});

  const [data, setData] = useState({
    cvc: '',
    expiryDate: '',
    expiryMonth: 1,
    expiryYear: new Date().getFullYear(),
    passport: '',
    cardNumber: ''
  });
  const handleInputChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });

  };

  const handlePassportChange = (e) => {
    const {value} = e.currentTarget;
    const max = 10;
    const currentLength = value.length;
    if (currentLength < max && (value === '' || /^[0-9]+$/.test(value))) {
      handleInputChange(e);
    }
  };

  useEffect(() => {
    setCardData(data);
  }, [data]);

  return (
    <div className={ 'payment-block credit-card-payment' }>
      <div className={ 'payment-content' }>

        <form
          className={ 'card-form' } onSubmit={ () => {
        } }>
          <div className={ 'form-input required card-number' }>
            <label htmlFor="apartment">{t('payment.credit_card.labels.card_number')}</label>

            <div className={ 'input-with-image' }>
              <svg { ...getCardImageProps({images}) } />
              <input
                { ...getCardNumberProps({
                    placeholder: t('payment.credit_card.placeholders.card_number'),
                    onChange: handleInputChange,
                    value: data.cardNumber
                  }
                ) } />
            </div>
            {meta.touchedInputs['cardNumber'] && meta.erroredInputs['cardNumber'] &&
              <div className={ 'input-error' }>
                <span>{meta.erroredInputs['cardNumber']}</span>
              </div>
            }

          </div>

          <div className={ 'form-row' }>
            <div className={ 'form-input required' }>
              <label htmlFor="apartment">{t('payment.credit_card.labels.expiry')}</label>
              <div className={ 'expiry-date-block' }>
                <select
                  className={ 'expiryMonth' }
                  name={ 'expiryMonth' }
                  onChange={ handleInputChange }
                  value={ data.expiryMonth }
                >
                  {Array.from(range(1, 13, 1)).map(number => (
                    <option>{number}</option>
                  ))}
                </select>
                <div className={ 'divider' }>/</div>
                <select
                  className={ '' }
                  name={ 'expiryYear' }
                  onChange={ handleInputChange }
                  value={ data.expiryYear }
                >
                  {Array.from(range(new Date().getFullYear(), new Date().getFullYear() + 10, 1)).map(number => (
                    <option>{number}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className={ 'form-input required cvc' }>
              <label htmlFor="apartment">{t('payment.credit_card.labels.cvc')}</label>
              <input
                { ...getCVCProps({
                  placeholder: t('payment.credit_card.placeholders.cvc'),
                  onChange: handleInputChange,
                  value: data.cvc
                }) } />
              {meta.touchedInputs['cvc'] && meta.erroredInputs['cvc'] &&
                <div className={ 'input-error' }>
                  <span>{meta.erroredInputs['cvc']}</span>
                </div>
              }
            </div>
          </div>

          <div className={ 'form-input required passport-block' }>
            <label htmlFor="cardNumber">{t('payment.credit_card.labels.passport')}</label>
            <input
              type="number"
              name="passport"
              className={ 'passport-input' }
              maxLength={ 10 }
              placeholder={ t('payment.credit_card.placeholders.passport') }
              onChange={ handlePassportChange }
              value={ data.passport }
            />
          </div>

          {/*<div>{meta.isTouched && meta.error && <span>Error: {meta.error}</span>}</div>*/}
        </form>
      </div>
    </div>
  );
};

export default withTranslation()(CreditCardPayment);
